<template>
    <div>
        <div class="row machine-box-container">
            <div class="col"></div>
            <div class="machine-box machine-box-1 col-3 shift-machine-box-wrapper">
                <template v-if="showShiftAlertNotification">
                    <div class="notification-overlay">
                        <div class="alert alert-danger alert-notification-container" role="danger">
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="156" height="156" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-circle">
                                    <polygon points="12,2 22,22 2,22"></polygon>
                                    <line x1="12" y1="10" x2="12" y2="14"></line>
                                    <line x1="12" y1="18" x2="12" y2="18"></line>
                                </svg>
                            </div>
                            <div class="alert-text-content">
                                <h4 class="alert-heading">{{ ShiftAlertHeaderText }}</h4>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="machine-box-title">
                    TURNO
                </div>
                <div class="machine-box-content">
                    <div class="production-line-info">
                        <div class="production-line-title dflex">
                            {{ productionLine ? productionLine.name : '' }}
                        </div>
                    </div>
                    <div class="stopped-time">
                        <div class="stopped-time-text dflex">
                            TIEMPO DE ATRASO
                        </div>
                        <div class="stopped-time-number danger-number dflex">
                            {{ stoppedTime ?? '00:00:00' }}
                        </div>
                    </div>
                    <div class="efficiency-number">
                        <vue-circle
                            ref="circle"
                            :progress="efficiencyPercentage"
                            :size="100"
                            :reverse="false"
                            line-cap="round"
                            :fill='{ gradient: [`${efficiencyPercentage > machine.target_oee ? "green" : "red"}`] }'
                            empty-fill="rgba(255, 255, 255, 1)"
                            :animation-start-value="0.0"
                            :start-angle="-1.55"
                            insert-mode="append"
                            :thickness="8"
                            :show-percent="true"
                        >
                        </vue-circle>
                    </div>
                    <div class="delayed-units">
                        <div class="delayed-units-text dflex">
                            UDS ATRASADAS
                        </div>
                        <div class="delayed-units-number danger-number dflex">
                            {{ delayedUnits < 0 ? 0 : delayedUnits }}
                        </div>
                    </div>
                </div>
            </div>
            <template>
                <div class="col-8 order-machine-box-wrapper">
                    <template v-if="showORAlertNotification">
                        <div class="notification-overlay">
                            <div class="alert alert-danger dflex alert-notification-container" role="danger">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="156" height="156" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-circle">
                                        <polygon points="12,2 22,22 2,22"></polygon>
                                        <line x1="12" y1="10" x2="12" y2="14"></line>
                                        <line x1="12" y1="18" x2="12" y2="18"></line>
                                    </svg>
                                </div>
                                <div class="alert-text-content">
                                    <h4 class="alert-heading">{{ ORAlertHeaderText }}</h4>
                                    <h5 class="alert-extra-info">
                                        <span class="text-collapser alert-extra-info-text">{{ timeDiffWithLastShiftOrFinishedORContext }}</span>
                                        <br>
                                        <span class="text-collapser alert-extra-info-value">{{ timeDiffWithLastShiftOrFinishedOR }}</span>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="row">
                        <div class="machine-box machine-box-2 col-9">
                            <div class="machine-box-title">ORDEN</div>
                            <div class="machine-box-content">
                                <!-- Contenido de machine-box-2 -->
                                <div class="row descrips-container">
                                    <div class="col-6 order-reference-descrip dflex">
                                        {{ firstTimeLoading ? 'Cargando...' : (orderReference ? orderReference.descrip : 'Sin orden en producción') }}
                                    </div>
                                    <div class="col" style="padding: 0;"></div>
                                    <div class="col-5 reference-descrip dflex">
                                        {{ firstTimeLoading ? 'Cargando...' : (reference ? reference.descrip : 'Sin referencia') }}
                                    </div>
                                </div>
                                <div class="row boxes-to-finished-order-row">
                                    <div class="col boxes-to-finished-order-text">PRODUCCIÓN</div>
                                    <div class="col boxes-to-finished-order-number">
                                        <div class="boxes-to-finished-order-number-division">
                                            <span :class="orderReferenceQuantityClasses">
                                                {{ orderReference ? orderReference.produced_quantity + '/' + orderReference.real_quantity : 0 +'/'+ 0}} CAJAS
                                            </span>
                                            <!-- <div class="boxes-to-finished-order-number-all-divisions" :class="orderReferenceDivisionsQuantityClasses">
                                                {{ orderReferenceDivisionsTotalData ? formattedTotalDivisionsProducedQuantityAndRealQuantity : 0+'/'+0 }} CAJAS
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="row current-weight-row">
                                    <div class="col current-weight-text dflex">PESO ACTUAL</div>
                                    <div class="col current-weight-number dflex">
                                        {{
                                            parseFloat(actualWeight ?? 0).toLocaleString('es', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }} kg
                                    </div>
                                </div>
                                <div class="row weight-gauge-information">
                                    <div class="col thumbs-icon-container">
                                        <StateHand :isOk="isOk" />
                                    </div>
                                    <div class="col-7">
                                        <div class="weight-gauge">
                                            <div class="scale">
                                                <RadialGraph
                                                    :percentage="percentage"
                                                    :okMaxPercentage="okMaxPercentage"
                                                    :weightDifference="weightDifference"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="machine-box machine-box-3 col-3">
                            <div class="machine-box-title">
                                ORDEN<br />
                                EN TURNO
                            </div>
                            <div class="machine-box-content">
                                <!-- Contenido de machine-box-3 -->
                                <div class="finished-boxes">
                                    <div class="number-finished-boxes dflex">{{ finishedBoxesOrderShift }}</div>
                                    <div class="text-finished-boxes dflex">CAJAS<br />FINALIZADAS</div>
                                </div>
                                <div class="accumulated-shift">
                                    <div
                                        class="info-icon-small-container"
                                        style="transform: scale(6); display: flex; justify-content: center; align-items: center; height: 8ch;"
                                    >
                                        <span class="mdi mdi-information-outline" style="color: #3c89bd;"></span>
                                    </div>
                                    <div class="accumulated-shift-text dflex">ACUMULADO</div>
                                    <div class="accumulated-shift-number dflex">
                                        {{
                                            (parseFloat(accumulated) || 0).toLocaleString('es', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }} kg
                                    </div>
                                    <div class="accumulated-shift-number-in-boxes amount-in-boxes dflex">
                                        {{ accumulatedBoxes }} CAJAS
                                    </div>
                                </div>
                                <div class="excess-shift">
                                    <div class="hand-small-container">
                                        <StateHand :isOk="false" />
                                    </div>
                                    <div class="excess-shift-text dflex">EXCESO</div>
                                    <div class="excess-shift-number dflex">
                                        {{
                                            (parseFloat(excess) || 0).toLocaleString('es', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })
                                        }} kg
                                    </div>
                                    <div class="excess-shift-number-in-boxes amount-in-boxes dflex">
                                        {{ excessBoxes }} CAJAS
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="col"></div>
        </div>
        <div class="home-button-container">
            <div class="btn btn-primary home-button" @click="goHome">
                <span class="mdi mdi-home"></span>
            </div>
        </div>
        <div v-if="productionStopped===true" class="overlay">
            <h1>{{reasonForStopping}}</h1>
        </div>
    </div>
</template>

<script>
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import RadialGraph from "../../common/components/RadialGraph.vue";
import StateHand from "../../common/components/StateHand.vue";
import {EchoUtils, EchoChannels, EchoEvents} from "../../common/echo";
import VueCircle from 'vue2-circle-progress';

export default {
    name: "machine-production-control",
    components: {
        RadialGraph,
        StateHand,
        VueCircle,
    },
    props: {
        machine: {
            type: Object,
            required: true,
        },
        productionLine: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            percentage: -100,
            okMaxPercentage: this.reference ? this.reference.admissible_excess * 1000 : 5,
            efficiencyPercentage: 0,
            weightDifference: 0,
            finishedBoxesOrderShift: 0,
            actualWeight: 0,
            stoppedTime: null,
            delayedUnits: 0,
            token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            orderReference: null,
            orderReferenceShiftMachineRecord: null,
            reference: null,
            // orderReferenceDivisionsTotalData: null,
            producedQuantity: 0,
            accumulated: 0,
            excess: 0,
            productionStopped: false,
            reasonForStopping: 'La producción se encuentra detenida',
            firstTimeLoading: true,
            timeDiffWithLastShiftOrFinishedOR: '0s',
            timeDiffWithLastShiftOrFinishedORContext: '',
            ORAlertHeaderText: '',
            ORProductionStopped: false,
            ShiftAlertHeaderText: '',
            ShiftProductionStopped: false,
            isLoadingMPCApiData: false,
        }
    },
    methods: {
        productionLineOrderMoved(value) {
            this.orderReference = value.orderReference;
            this.reference = value.reference;
            this.producedQuantity=this.orderReference?.produced_quantity;
            this.actualWeight = 0;
            this.weightDifference = 0;
        },
        secondsToHms(d) {
            d = Number(d);
            let h = Math.floor(d / 3600);
            let m = Math.floor(d % 3600 / 60);
            let s = Math.floor(d % 3600 % 60);

            let hDisplay = h < 10 ? '0' + h : h;
            let mDisplay = m < 10 ? '0' + m : m;
            let sDisplay = s < 10 ? '0' + s : s;
            return hDisplay + ':' + mDisplay + ':' + sDisplay;
        },
        prepareEchoListeners() {
            window.Echo.private(EchoChannels.PRIVATE.MACHINES(this.machine.id))
                .listen(EchoEvents.GROSS_WEIGHT_DATA_RECEIVED_EVENT, (data) => {
                    this.grossWeightDataReceivedEventHandler(data.data.gross_weight_ref);
                })
            EchoUtils.private(EchoChannels.PRIVATE.MACHINES(this.machine.id), EchoEvents.CONTROL_WEIGHT_DATA_RECEIVED_EVENT, (data) => {
                this.controlWeightDataReceivedEventHandler(data);
                this.newBoxReceived();
            });
            window.Echo.private(EchoChannels.PRIVATE.GLOBAL_PRODUCTION)
                .listen(EchoEvents.RELOAD_WEB_CLIENT_EVENT, () => {
                    this.reloadPage();
                })
            window.Echo.private(EchoChannels.PRIVATE.PRODUCTION_LINES(this.productionLine.id))
                .listen(EchoEvents.PRODUCTION_STARTED_EVENT, () => {
                    this.productionStartedEventHandler();
                })
                .listen(EchoEvents.PRODUCTION_STOPPED_EVENT, () => {
                    this.productionStoppedEventHandler();
                })
                .listen(EchoEvents.PRODUCTION_PAUSED_EVENT, () => {
                    this.productionLinePausedEventHandler();
                })
                .listen(EchoEvents.PRODUCTION_UNPAUSED_EVENT, () => {
                    this.productionLineUnPausedEventHandler();
                })
                .listen(EchoEvents.PRODUCTION_LINE_ORDER_MOVED_EVENT, (data) => {
                    this.productionLineOrderMoved(data);
                });
        },
        goHome() {
            window.location.href = '/home';
        },
        getCurrentOrderReferenceData(machineId) {
            this.isLoadingMPCApiData = true;
            return axios.get(`/api/machine/production-control/${machineId}`)
                .then(response => {
                    console.log(response.data)
                    this.orderReference = response.data.orderReferenceInProduction;
                    this.orderReferenceShiftMachineRecord = response.data.orderReferenceShiftMachineRecord;
                    this.reference = response.data.reference;
                    // this.orderReferenceDivisionsTotalData = response.data.orderReferenceDivisionsTotalData;
                    this.producedQuantity = response.data.orderReferenceInProduction.produced_quantity;
                    this.finishedBoxesOrderShift = response.data.orderReferenceShiftMachineRecord.produced_quantity;
                    this.accumulated = response.data.orderReferenceShiftMachineRecord.weight_accumulated;
                    this.excess = response.data.orderReferenceShiftMachineRecord.weight_excess;
                    this.stoppedTime = this.secondsToHms(response.data.delayedData.stoppedTimeInSeconds);
                    this.delayedUnits = response.data.delayedData.boxesDelayed;
                    this.efficiencyPercentage = response.data.delayedData.efficiencyPercentage;
                    this.timeDiffWithLastShiftOrFinishedOR = response.data.delayedData.timeDiffWithLastShiftOrFinishedOR;
                    this.timeDiffWithLastShiftOrFinishedORContext = response.data.delayedData.timeDiffWithLastShiftOrFinishedORContext;
                    this.ORAlertHeaderText = response.data.ORReasonForStopping;
                    this.ORProductionStopped = response.data.ORProductionStopped;
                    this.ShiftAlertHeaderText = response.data.ShiftReasonForStopping;
                    this.ShiftProductionStopped = response.data.ShiftProductionStopped;
                    this.firstTimeLoading = false;
                    this.isLoadingMPCApiData = false;
                    // this.productionStopped = response.data.productionStopped;
                    // this.reasonForStopping = response.data.reasonForStopping;
                    setTimeout(() => {
                        this.$refs.circle.updateProgress(this.efficiencyPercentage);
                        this.$refs.circle.updateFill({gradient: [`${this.efficiencyPercentage >= this.machine.target_oee ? "green" : "red"}`]});
                    }, 500);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        controlWeightDataReceivedEventHandler(data) {
            this.updateShiftData(data.controlWeightData);
        },
        grossWeightDataReceivedEventHandler(weight) {
            this.actualWeight = weight;
            this.weightDifference = weight - this.reference.gross_weight;
            this.percentage = (this.weightDifference / this.reference.gross_weight) * 100;
        },
        async newBoxReceived() {
            this.finishedBoxesOrderShift++;
            this.producedQuantity++;
            this.delayedUnits--;
        },
        productionStoppedEventHandler() {
            this.productionStopped = true;
            this.reasonForStopping = 'La producción se encuentra detenida';
        },
        productionStartedEventHandler() {
            if(!this.isLoadingMPCApiData)
            {
                this.getCurrentOrderReferenceData(this.machine.id)
            }
            this.productionStopped = false;
            this.cleanShiftData();
        },
        productionLinePausedEventHandler() {
            this.productionStopped = true;
            this.reasonForStopping = 'La producción se encuentra pausada';
        },
        productionLineUnPausedEventHandler() {
            this.productionStopped = false;
        },
        updateShiftData(controlWeightData) {
            let weightDifference = controlWeightData.value - this.reference.gross_weight;
            if(weightDifference > 0) {
                this.excess = parseFloat(this.excess) + parseFloat(weightDifference);
            }
            this.accumulated = parseFloat(this.accumulated) + parseFloat(controlWeightData.value);
        },
        cleanShiftData() {
            this.accumulated = 0,
            this.excess = 0,
            this.finishedBoxesOrderShift = 0;
            this.actualWeight = 0;
            this.stoppedTime = null;
            this.delayedUnits = 0;
            this.producedQuantity = 0;
        },
        reloadPage() {
            location.reload();
        }
    },
    computed: {
        isOk() {
            return (this.percentage <= this.okMaxPercentage && this.percentage >= 0);
        },
        leftBoxes() {
            if(!this.orderReference || this.orderReference.real_quantity - this.producedQuantity < 0) return 0;
            return Math.abs(this.orderReference?.real_quantity - this.producedQuantity);
        },
        accumulatedBoxes() {
            if(!this.reference || this.reference.gross_weight <= 0) return 0;
            return Math.floor(this.accumulated / this.reference.gross_weight);
        },
        excessBoxes() {
            if(!this.reference || this.reference.gross_weight <= 0) return 0;
            return Math.floor(this.excess / this.reference.gross_weight);
        },
        hasOrderReferenceInProduction() {
            return this.orderReference && this.orderReference.created_at;
        },
        hasOrderReferenceShiftMachineRecord() {
            return this.orderReferenceShiftMachineRecord && this.orderReferenceShiftMachineRecord.created_at;
        },
        showORAlertNotification() {
            return this.ORProductionStopped && !this.firstTimeLoading;
        },
        showShiftAlertNotification() {
            return this.ShiftProductionStopped && !this.firstTimeLoading;
        },
        // formattedTotalDivisionsProducedQuantityAndRealQuantity() {
        //     return `${this.orderReferenceDivisionsTotalData ? this.orderReferenceDivisionsTotalData.produced_quantity : 0}/${this.orderReferenceDivisionsTotalData ? this.orderReferenceDivisionsTotalData.real_quantity : 0}`;
        // },
        orderReferenceQuantityClasses() {
            let classes = {};
            if(this.leftBoxes <= 0) {
                classes['danger-quantity'] = true;                
                classes['danger-quantity-blink'] = true;
            }
            return classes;
        },
    },
    async beforeMount() {
        this.prepareEchoListeners();
        await this.getCurrentOrderReferenceData(this.machine.id);
        setInterval(() => {
            this.getCurrentOrderReferenceData(this.machine.id)
        }, 5000);
    },
}
</script>